/*
 *
 * BadgesList constants
 *
 */

export const DEFAULT_ACTION = 'app/BadgesList/DEFAULT_ACTION';
export const GET_ALL_BADGES_REQUEST = 'app/BadgesList/GET_ALL_BADGES_REQUEST';
export const GET_ALL_BADGES_SUCCESS = 'app/BadgesList/GET_ALL_BADGES_SUCCESS';
export const GET_ALL_BADGES_FAILURE = 'app/BadgesList/GET_ALL_BADGES_FAILURE';
export const UPDATE_BADGE_STATUS_REQUEST =
  'app/BadgesList/UPDATE_BADGE_STATUS_REQUEST';
export const UPDATE_BADGE_STATUS_SUCCESS =
  'app/BadgesList/UPDATE_BADGE_STATUS_SUCCESS';
export const UPDATE_BADGE_STATUS_FAILURE =
  'app/BadgesList/UPDATE_BADGE_STATUS_FAILURE';
export const GET_BADGE_IMAGE_REQUEST = 'app/BadgesList/GET_BADGE_IMAGE_REQUEST';
export const GET_BADGE_IMAGE_SUCCESS = 'app/BadgesList/GET_BADGE_IMAGE_SUCCESS';
export const GET_BADGE_IMAGE_FAILURE = 'app/BadgesList/GET_BADGE_IMAGE_FAILURE';
export const PUT_BADGE_IMAGE_REQUEST = 'app/BadgesList/PUT_BADGE_IMAGE_REQUEST';
export const PUT_BADGE_IMAGE_SUCCESS = 'app/BadgesList/PUT_BADGE_IMAGE_SUCCESS';
export const PUT_BADGE_IMAGE_FAILURE = 'app/BadgesList/PUT_BADGE_IMAGE_FAILURE';
export const SET_CREATE_BADGE_MODE = 'app/BadgesList/SET_CREATE_BADGE_MODE';

export const ABSOLUTE = 'ABSOLUTE';
export const COUPONS = 'COUPONS';
export const COUPON = 'COUPON';
export const LOYALTY_PROMOTION = 'LOYALTY_PROMOTION';
export const LOYALTY_PROMOTIONS = 'LOYALTY_PROMOTIONS';
export const POINTS = 'POINTS';
export const PAUSE = 'PAUSE';
export const STATUS_FILTER = 'statusFilter';
export const CLAIMED_BY_FILTER = 'claimedByFilter';
export const OWNED_BY_FILTER = 'ownedByFilter';
export const ACTIVATION_FILTER = 'activationFilter';
export const EARN_TYPE_FILTER = 'earnTypeFilter';
export const ACTIVATE = 'ACTIVATE';
export const DEACTIVATE = 'DEACTIVATE';
export const ACTIVATED = 'ACTIVATED';
export const DE_ACTIVATED = 'DE_ACTIVATED';
export const DESC = 'DESC';
export const ASC = 'ASC';
export const LAST_UPDATED_DATE = 'LAST_UPDATED_DATE';
export const ENGAGE = 'engage';
export const JOURNEY = 'journey';
export const ISSUE_EARN = 'ISSUE_EARN';
export const EARN = 'EARN';
export const CAMPAIGNS_OWNER = 'Audience_Campaigns';
export const UPCOMING_LIVE_STATUS = 'UPCOMING&status=LIVE';
export const BADGES_ENROLL = 'BADGES_ENROLL';
export const BADGES_ISSUE = 'BADGES_ISSUE';

export const activationFilterMap = {
  ACTIVE: ACTIVATED,
  INACTIVE: DE_ACTIVATED,
};

export const moduleFilterMap = {
  LOYALTY: 'Loyalty',
  LOYALTY_PROMOTION: 'Loyalty_Promotion',
  REFERRAL_CAMPAIGNS: 'Referral_Campaigns',
  JOURNEY: 'Journeys',
  AUDIENCE_CAMPAIGNS: 'Audience_Campaigns',
  REWARDS_CATALOG: 'Rewards_Catalog',
  GOODWILL_MODULE: 'Goodwill_Module',
  MILESTONE: 'Milestones',
};

export const reverseModuleFilterMap = {
  Loyalty: 'LOYALTY',
  Loyalty_Promotion: 'LOYALTY_PROMOTION',
  Referral_Campaigns: 'REFERRAL_CAMPAIGNS',
  Journeys: 'JOURNEY',
  Audience_Campaigns: 'AUDIENCE_CAMPAIGNS',
  Rewards_Catalog: 'REWARDS_CATALOG',
  Goodwill_Module: 'GOODWILL_MODULE',
  Milestones: 'MILESTONE',
};

export const COLUMN_WIDTH = {
  badgesImage: '5%',
  badges: '17.6%',
  duration: '17.5%',
  benefitsLinked: '17.5%',
  issueExpiry: '13.1%',
  badgesIssued: '13%',
  lastUpdatedOn: '14.5%',
};

export const COLUMN_WIDTH_EMBEDDED = {
  badgesImage: '5.43%',
  badges: '21.74%',
  duration: '21.74%',
  benefitsLinked: '18.48%',
  issueExpiry: '18.48%',
  lastUpdatedOn: '14.13%',
};

export const PARENT_MODULE_MAP = {
  [JOURNEY]: 'Journeys',
  [ENGAGE]: 'Audience_Campaigns',
};

export const LIST = 'LIST';